window.addEventListener('DOMContentLoaded', function(event){

	window.onbeforeprint = function() {

		var $lazy = $('img[loading="lazy"]')

		var $lazySrc = $('img[data-lazy-src]')

		//Native WordPress lazyload
		if($lazy.length) {
			$lazy.removeAttr('loading')
		}

		//WP Rocket Lazyload
		if($lazySrc.length) {
			$lazy.each(function() {
				$(this).attr('src', $(this).data('lazy-src'))
				$(this).removeAttr('data-lazy-src')
			})
		}

	}

})